export type DocumentsTabMessages = {
  statementTabTitle: string;
  ratesTabTitle: string;
  documentsTabTitle: string;

  documentsTabDescription: string;
  ownerDocumentsTitle: string;
  uploadButtonLabel: string;

  documentNotSentMessage: string;
  uploadInstructionNotSent: string;

  uploadInstruction: string;
  documentRejectedMessage: string;
  approvedMessage: string;
  loadingMessage: string;
  errorMessage: string;
  errorTitle: string;
  errorDescription: string;
  errorDescriptionBankAccount: string;
  errorAlt: string;

  // Situação Cadastral
  cadastralSituationTitle: string;
  cadastralSituationDescription: string;

  // Novos textos
  directorDocumentsTitle: string;
  documentPendingMessage: string;
  uploadInstructionPending: string;
  documentAwaitingApprovalMessage: string;
  uploadInstructionAwaitingApproval: string;
};

export const DOCUMENTS_TAB_MESSAGES: DocumentsTabMessages = {
  statementTabTitle: "Extrato",
  ratesTabTitle: "Taxas",
  documentsTabTitle: "Documentos",
  documentsTabDescription:
    "Abaixo estão os documentos que você deve nos enviar. Todas as cópias devem ser coloridas, frente e verso, legíveis, sem desfoque e sem cortes. Após anexar todos os documentos, clique no botão 'Enviar documentos para análise' para concluir o envio.",
  ownerDocumentsTitle: "Documentos do proprietário",
  uploadButtonLabel: "Enviar",

  uploadInstruction: "Para enviar este documento, clique no botão",
  documentRejectedMessage: "Documento rejeitado.",

  documentNotSentMessage: "Documento não enviado.",
  uploadInstructionNotSent: "Para enviar este documento, clique no botão.",

  approvedMessage: "Aprovado",
  loadingMessage: "Carregando...",
  errorMessage: "Erro ao carregar documentos.",
  errorTitle: "Erro ao carregar",
  errorDescription: "Não foi possível carregar os documentos.",

  errorDescriptionBankAccount: "Não foi possível carregar as contas.",
  errorAlt: "Erro no carregamento de documentos",

  // Situação Cadastral
  cadastralSituationTitle: "Situação Cadastral",
  cadastralSituationDescription: "Confira a situação cadastral do seu registro aqui.",

  // Novos textos
  directorDocumentsTitle: "Documentos referentes ao sócio diretor",
  documentPendingMessage: "Documento pendente.",
  uploadInstructionPending: "Estamos aguardando o envio deste documento.",
  documentAwaitingApprovalMessage: "Documento aguardando aprovação.",
  uploadInstructionAwaitingApproval: "Este documento está sendo analisado para aprovação.",
};
